import { Link } from "react-router-dom";
import { BOOKING_URL, ASSETS, BUSINESS } from "@/lib/constants";
import { Mail, Phone, MapPin, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-[#e5e7eb]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img
            src={ASSETS.ashlanLogo}
            alt="Ashlan Clinic"
            className="h-10 w-auto object-contain mb-6"
          />
          <p className="text-[#3C4048] text-base max-w-md leading-relaxed">
            One of Bermuda's most trusted clinical massage therapy practices.
            Evidence-based treatment. Lasting transformation.
          </p>
          <p
            data-testid="footer-tagline"
            className="mt-6 text-[#3A7A8C] font-bold tracking-[0.18em] text-sm uppercase"
          >
            {BUSINESS.tagline}
          </p>
        </div>

        <div>
          <div className="ash-eyebrow mb-4">Explore</div>
          <ul className="flex flex-col gap-3 text-[#3C4048]">
            <li>
              <Link
                data-testid="footer-link-services"
                to="/services"
                className="hover:text-[#080808]"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-team"
                to="/team"
                className="hover:text-[#080808]"
              >
                Our Team
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-therabody"
                to="/therabody"
                className="hover:text-[#080808]"
              >
                Therabody Products
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-learn"
                to="/learn"
                className="hover:text-[#080808]"
              >
                Learning Hub
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-corporate"
                to="/corporate-wellness"
                className="hover:text-[#080808]"
              >
                Corporate Wellness
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-contact"
                to="/contact"
                className="hover:text-[#080808]"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-staff-portal"
                to="/staff"
                className="hover:text-[#080808]"
              >
                Staff Portal
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="ash-eyebrow mb-4">Contact</div>
          <ul className="flex flex-col gap-3 text-[#3C4048]">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-1 text-[#5FA8B4]" />
              <span>
                {BUSINESS.address1}
                <br />
                {BUSINESS.address2}, {BUSINESS.country}
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-1 text-[#5FA8B4]" />
              <a
                href={BUSINESS.phoneHref}
                className="hover:text-[#080808]"
                data-testid="footer-phone"
              >
                {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-1 text-[#5FA8B4]" />
              <a
                href={`mailto:${BUSINESS.email}`}
                className="hover:text-[#080808]"
                data-testid="footer-email"
              >
                {BUSINESS.email}
              </a>
            </li>
          </ul>
          <a
            href={BOOKING_URL}
            className="ash-link-underline mt-6"
            data-testid="footer-book-link"
          >
            Book Your Session
          </a>
        </div>
      </div>

      <div className="border-t border-[#e5e7eb]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-sm text-[#6B7280]">
            © {new Date().getFullYear()} Ashlan Clinic. All rights reserved.
            <span className="ml-2 text-xs text-[#9CA3AF]" data-testid="footer-powered-by">
              · Powered by{" "}
              <a
                href="https://suitestax.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#3A7A8C] underline-offset-2 hover:underline"
                data-testid="footer-suitestax-link"
              >
                SuiteStax
              </a>
            </span>
          </p>
          <div className="flex items-center gap-5 text-sm text-[#6B7280]">
            <a
              href="https://stats.uptimerobot.com/GivWo8aidQ"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-status-link"
              className="hover:text-[#080808] inline-flex items-center gap-1.5"
            >
              <span className="w-2 h-2 rounded-full bg-[#10B981] inline-block" aria-hidden />
              System Status
            </a>
            <p className="uppercase tracking-[0.18em]">
              Bermuda · Clinical Massage Therapy
            </p>
            <Link
              to="/admin/login"
              data-testid="footer-admin-login-link"
              className="hover:text-[#080808] inline-flex items-center gap-1.5"
            >
              <Lock size={12} /> Admin Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
